module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui stackable three cards"
  }, _vm._l((_vm.goods), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "ui fluid card",
      class: [{
        complementary_view: _vm.in_complementary == item.id && _vm.complementary_index == index
      }, {
        replacement_view: _vm.in_replacement == item.id && _vm.replacement_index == index
      }],
      staticStyle: {
        "position": "relative",
        "margin-right": "10px"
      },
      attrs: {
        "id": item.id,
        "index": index
      }
    }, [_c('div', {
      staticClass: "badges",
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('discount-tag', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "item": item
      }
    }), _vm._v(" "), _vm._l((item.badges), function(badge) {
      return _c('div', {
        key: badge.id,
        staticClass: "ui labels",
        staticStyle: {
          "display": "inline-block"
        }
      }, [_c('a', {
        staticClass: "ui label",
        style: ({
          backgroundColor: '#' + badge.color,
          color: '#210404'
        })
      }, [_vm._v(_vm._s(badge.label))])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "img_height",
      staticStyle: {
        "position": "relative",
        "margin-left": "10px",
        "margin-right": "11px",
        "text-align": "center"
      }
    }, [(_vm.in_complementary == item.id || _vm.in_replacement == item.id) ? _c('div', [(_vm.in_replacement == item.id && _vm.replacement_index == index) ? _c('button', {
      staticClass: "circular ui icon button replacement close shadow",
      attrs: {
        "item-id": item.id
      },
      on: {
        "click": function($event) {
          return _vm.replacement(index, item, -2)
        }
      }
    }, [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), (_vm.in_complementary == item.id && _vm.complementary_index == index) ? _c('button', {
      staticClass: "circular ui icon custom_brown button complementary close shadow",
      attrs: {
        "item-id": item.id
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.complementary(index, item, -2)
        }
      }
    }, [_vm._m(2, true)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {}, [(_vm.outofstock === item.id && !_vm.in_replacement && !_vm.in_complementary && _vm.replacement_array[0].length > 0 && _vm.replacement_index == index) ? _c('button', {
      staticClass: "circular ui icon button replacement shadow",
      on: {
        "click": function($event) {
          return _vm.replacement(index, item, 0)
        }
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "font-size": "30px"
      }
    }, [(_vm.replacement_arrow[0].length > 0) ? _c('strong', [_vm._v(_vm._s(_vm.replacement_arrow[0].length))]) : _c('strong', {
      staticStyle: {
        "font-size": "15px",
        "background-color": "white"
      }
    }, [_vm._v("0")])]), _vm._v(" "), _vm._m(3, true)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.show_complementary), function(result) {
      return (result == item.id && !_vm.in_replacement && !_vm.in_complementary && _vm.complementary_array[item.id].length > 0 && _vm.complementary_index == index) ? _c('button', {
        key: result,
        staticClass: "circular ui icon custom_brown button complementary shadow",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.complementary(index, item, 0)
          }
        }
      }, [_c('div', [_c('span', {
        staticStyle: {
          "font-size": "30px"
        }
      }, [_c('strong', [_vm._v(_vm._s(_vm.complementary_array[item.id].length))])]), _vm._v(" "), _vm._m(4, true)])]) : _vm._e()
    })], 2), _vm._v(" "), _c('v-touch', {
      attrs: {
        "v-if": !_vm.in_complementary == item.id && !_vm.in_replacement == item.id
      }
    }, [_c('v-touch', {
      attrs: {
        "enabled": _vm.in_complementary == item.id
      },
      on: {
        "swiperight": function($event) {
          return _vm.complementary(index, item, -1)
        },
        "swipeleft": function($event) {
          return _vm.complementary(index, item, 1)
        }
      }
    }, [_c('v-touch', {
      attrs: {
        "enabled": _vm.in_replacement == item.id
      },
      on: {
        "swiperight": function($event) {
          return _vm.replacement(index, item, -1)
        },
        "swipeleft": function($event) {
          return _vm.replacement(index, item, 1)
        }
      }
    }, [(item.images[0]) ? _c('img', {
      staticClass: "ui centered image",
      attrs: {
        "src": item.images[0].url
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$router.push('/good/' + item.link)
        }
      }
    }) : _c('img', {
      staticClass: "ui centered image",
      attrs: {
        "src": 'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/' + item.id + '.jpg'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$router.push('/good/' + item.link)
        }
      }
    }), _vm._v(" "), ((_vm.in_complementary == item.id && _vm.complementary_index == index) || (_vm.in_replacement == item.id && _vm.replacement_index == index)) ? _c('div', [(_vm.in_complementary == item.id) ? _c('a', {
      staticClass: "prev",
      staticStyle: {
        "left": "0"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.complementary(index, item, -1)
        }
      }
    }, [_vm._v("❮")]) : (_vm.in_replacement == item.id) ? _c('a', {
      staticClass: "prev",
      staticStyle: {
        "left": "0"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.replacement(index, item, -1)
        }
      }
    }, [_vm._v("❮")]) : _vm._e(), _vm._v(" "), (_vm.in_complementary == item.id) ? _c('a', {
      staticClass: "next",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.complementary(index, item, 1)
        }
      }
    }, [_vm._v("❯")]) : (_vm.in_replacement == item.id) ? _c('a', {
      staticClass: "next",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.replacement(index, item, 1)
        }
      }
    }, [_vm._v("❯")]) : _vm._e()]) : _vm._e()])], 1)], 1), _vm._v(" "), _vm._l((_vm.complementary_arrow[_vm.parent_item.id]), function(complement_id) {
      return (_vm.in_complementary == item.id && _vm.complementary_index == index) ? _c('div', {
        key: complement_id,
        staticClass: "carousel-dots",
        staticStyle: {
          "display": "inline-block"
        }
      }, [(complement_id == item.id) ? _c('span', {
        staticClass: "dot active custom_dots"
      }) : _c('span', {
        staticClass: "dot custom_dots"
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.replacement_arrow[0]), function(related_id) {
      return (_vm.in_replacement == item.id && _vm.replacement_index == index) ? _c('div', {
        key: related_id,
        staticClass: "carousel-dots",
        staticStyle: {
          "display": "inline-block"
        }
      }, [(related_id == item.id) ? _c('span', {
        staticClass: "dot active custom_dots"
      }) : _c('span', {
        staticClass: "dot custom_dots"
      })]) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('router-link', {
      staticClass: "header",
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "to": '/good/' + item.link
      }
    }, [_vm._v(_vm._s(item.goods_name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('div', {
      staticClass: "ui tag labels pa-tag-wrapper"
    }, [_c('price-tag', {
      attrs: {
        "item": item
      }
    }), _vm._v(" "), (item.bail > 0) ? _c('a', {
      staticClass: "ui green label"
    }, [_vm._v("Drošības nauda: " + _vm._s(item.bail) + " €")]) : _vm._e(), _vm._v(" "), _c('auto-ship', {
      attrs: {
        "item": item
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.description))])], 1), _vm._v(" "), (!_vm.checkIfInCart(item)) ? _c('button', {
      staticClass: "ui bottom attached button",
      on: {
        "click": function($event) {
          return _vm.addItemToCart(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "add icon"
    }), _vm._v(" Pievienot\n      ")]) : _c('div', {
      staticClass: "ui three bottom attached  buttons"
    }, [_c('div', {
      staticClass: "ui  button",
      on: {
        "click": function($event) {
          return _vm.reduceItemInCart(item)
        }
      }
    }, [_c('i', {
      staticClass: "minus icon"
    })]), _vm._v(" "), _c('button', {
      staticClass: "ui  vertical animated button",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'cart'
          })
        }
      }
    }, [_c('div', {
      staticClass: "ui hidden content"
    }, [_vm._v("Uz grozu")]), _vm._v(" "), _c('div', {
      staticClass: "ui visible content"
    }, [_c('i', {
      staticClass: "cart icon"
    }), _vm._v("\n            " + _vm._s(_vm.howManyInCart(item)) + " gab.\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          return _vm.addItemToCart(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "add icon popup out-of-stock-popup",
      attrs: {
        "id": 'good_item_' + item.id,
        "data-content": "Diemžēl pieejamo preču skaits noliktavā ir ierobežots, lūdzu apskatiet līdzīgās preces."
      }
    })])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ui container",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "ui right floated custom_brown button",
    on: {
      "click": _vm.repeatLastOrder
    }
  }, [_c('i', {
    staticClass: "icon cart"
  }), _vm._v(" Atkārtot pēdējo\n      pasūtījumu\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui dividing header"
  }, [_c('i', {
    staticClass: "history icon",
    staticStyle: {
      "overflow": "visible",
      "position": "relative"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      Iepriekš pasūtītās preces\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('strong', [_c('i', {
    staticClass: "close icon"
  })])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "word-break": "break-all",
      "display": "block",
      "margin-top": "5px"
    }
  }, [_c('small', {
    staticClass: "options"
  }, [_vm._v("Līdzīgas preces")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('strong', [_c('i', {
    staticClass: "close icon"
  })])]), _vm._v(" "), _c('span', [_c('small', {
    staticClass: "options"
  }, [_vm._v("Saistītās preces")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {}, [_c('small', {
    staticClass: "options"
  }, [_vm._v("Līdzīgas preces")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('small', {
    staticClass: "options"
  }, [_vm._v("Saistītās preces")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b3ebe26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeLastOrderedGoods.vue
// module id = 339
// module chunks = 1